/**
 * AdminProtectedRoute - Platform admin role guard
 *
 * Protects admin routes - only platform administrators can access.
 * Regular users are redirected to the main dashboard.
 */

import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "@/contexts/AuthContext";

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

export const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const authContext = useContext(AuthContext);

  if (!authContext) {
    throw new Error("AdminProtectedRoute must be used within AuthProvider");
  }

  // ProtectedRoute handles the unauthenticated case, but belt-and-suspenders
  if (!authContext.isAuthenticated) {
    return null;
  }

  if (!authContext.tokenManagement.isPlatformAdmin()) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
